<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="wrap-relative override-global-font">
	<mat-extended-select
		[placeholder]="placeholderText"
		[option$]="internalListSubject$"
		[formControl]="internalField"
		[includeFilter]="true"
		[valuePath]="['value']"
		subScriptSizing="dynamic"
	>
	</mat-extended-select>

	<error-pin
		class="l-drop-error-top-right"
		[messageHeader]="(errorState | async)?.messageHeader"
		[message]="(errorState | async)?.message"
		*ngIf="showErrorPin"
	></error-pin>
</div>
